// src/utils/sign.js
export async function sign(body) {
  const secret = import.meta.env.VITE_SIGN_SECRET
  if (!secret) throw new Error("Missing VITE_SIGN_SECRET")
  const enc = new TextEncoder().encode(secret)
  const data = new TextEncoder().encode(body)
  const key = await crypto.subtle.importKey("raw", enc, { name: "HMAC", hash: "SHA-256" }, false, ["sign"])
  const sigBuf = await crypto.subtle.sign("HMAC", key, data)
  return Array.from(new Uint8Array(sigBuf))
    .map(b => b.toString(16).padStart(2, "0"))
    .join("")
}
